module.exports = __webpack_public_path__ + "img/domains-step-1.en.578d6b23.png";